export default {"src":"/_next/static/media/hexwrenchCar_24.93540074.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};